module.exports = __webpack_public_path__ + "img/4.e43ece02.png";